import {ValueObject} from '@s-ui/domain'

export class ImageValueObject extends ValueObject {
  #value

  constructor({src}) {
    super()
    this.#value = src
  }

  static create({src}) {
    return new ImageValueObject({src})
  }

  static createFromApi({Url}) {
    return ImageValueObject.create({src: Url})
  }

  static createFromVehicleImage({url}) {
    return ImageValueObject.create({src: url})
  }

  get value() {
    return this.#value
  }

  toJSON() {
    return {src: this.#value}
  }
}
